import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DateUtilService } from 'gung-common';
import { ListItemRendererComponent } from 'gung-list';
import { first, Subject } from 'rxjs';
import { ReturnOrder } from '../../models/return-order';
import { AuthService } from '../../services/auth/auth.service';
import { PriceConfigService } from '../../services/price-config/price-config.service';

@Component({
    selector: 'lib-return-order-card-list',
    templateUrl: './return-order-card-list.component.html',
    styleUrls: ['./return-order-card-list.component.scss'],
    standalone: false
})
export class ReturnOrderCardListComponent extends ListItemRendererComponent<ReturnOrder[]> implements OnInit, AfterViewInit {
  public dateUtilService = inject(DateUtilService);
  protected authService = inject(AuthService);
  protected router = inject(Router);

  isSales = false;

  constructor(
    public priceConfigService: PriceConfigService
  ) {
    super();
  }

  ngOnInit() {
    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        this.isSales = roles.includes('SALES');
      });
  }

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  goToDetail(returnOrder: ReturnOrder): void {
    // Navigate to return order detail if needed
  }
}
